import { ResultsModel, StructureType } from '@/lib/model';
import * as React from 'react';
import { Footer } from './Footer';
import './index.scss';
import { Option } from './Option';
import { ResultsStructure } from './ResultsStructure';
import { Social } from './Social';
import { Switch } from './Switch';

export interface ResultsComponentProps extends ResultsModel {
  onAddressClick: () => void;
  shareUrl: string;
}

export const ResultsComponent: React.FC<ResultsComponentProps> = ({
  cityName,
  fullAddress,
  structures,
  onAddressClick,
  shareUrl,
}) => {
  const [isCameraSelected, setIsCameraSelected] = React.useState(true);
  const [isModalOpened, setIsModalOpened] = React.useState(false);

  return (
    <div className="Results">
      <Option label="Comune" value={cityName} />
      <Option
        label="Indirizzo cercato"
        value={fullAddress}
        onClick={onAddressClick}
      />
      <Switch value={isCameraSelected} toggleView={setIsCameraSelected} />
      <ResultsStructure
        structure={isCameraSelected ? structures[0] : structures[1]}
        isModalOpened={isModalOpened}
        setIsModalOpened={setIsModalOpened}
        structureType={
          isCameraSelected ? StructureType.CAMERA : StructureType.SENATE
        }
      />
      <div className="Results__content">
        <Social
          collegeCameraName={structures[0].collegeName}
          collegeSenateName={structures[1].collegeName}
          shareUrl={shareUrl}
        />
        <Footer />
      </div>
    </div>
  );
};
